import type { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';

import type { State } from 'app/shared/types/State';

export type AppDispatch = ThunkDispatch<State, unknown, AnyAction>;

export const useAppDispatch: () => AppDispatch = useDispatch;
